export var IntelligentPhotoCaptureContextUpdateOperation;
(function (IntelligentPhotoCaptureContextUpdateOperation) {
    IntelligentPhotoCaptureContextUpdateOperation["DELETE"] = "DELETE";
    IntelligentPhotoCaptureContextUpdateOperation["UPLOAD"] = "UPLOAD";
    IntelligentPhotoCaptureContextUpdateOperation["RETAKE"] = "RETAKE";
})(IntelligentPhotoCaptureContextUpdateOperation || (IntelligentPhotoCaptureContextUpdateOperation = {}));
//# sourceMappingURL=IntelligentPhotoCaptureContextUpdateOperation.js.map